export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const EXPIRATION_DATE = "expirationDate";
export const REMEMBER_ME = "rememberMe";
